import { Component, Input, OnInit } from '@angular/core';
import { routerTransition } from 'mx-commons';
import { Router } from '@angular/router';
import { NotificationPopup } from 'src/app/model/notificationPopUp';

@Component({
	selector: 'app-card-notification',
	templateUrl: './card-notification.component.html',
	styleUrls: ['./card-notification.component.scss'],
	animations: [routerTransition()]
})
export class CardNotificationComponent {

	@Input()
	notification: NotificationPopup;

	constructor(private readonly router: Router) {

	}

	openAnalyze(analyze: NotificationPopup): void {
		this.router.navigate([`analysecredit/${analyze.id}`]);
	}

}
